"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScriptsPathBuilder_1 = require("./ScriptsPathBuilder");
var PathModuleConfigBuilder = /** @class */ (function () {
    function PathModuleConfigBuilder(scriptsPathBuilder) {
        this.scriptsPathBuilder = scriptsPathBuilder;
        this.scriptsPathBuilder = this.scriptsPathBuilder !== undefined && this.scriptsPathBuilder !== null
            ? this.scriptsPathBuilder
            : new ScriptsPathBuilder_1.ScriptsPathBuilder();
    }
    PathModuleConfigBuilder.prototype.build = function (scriptsConfig) {
        var paths = {};
        var modPathsStrings = this.scriptsPathBuilder.build(scriptsConfig);
        scriptsConfig.forEach(function (module, index) {
            paths[module.moduleName] = modPathsStrings[index];
        });
        return paths;
    };
    return PathModuleConfigBuilder;
}());
exports.PathModuleConfigBuilder = PathModuleConfigBuilder;
//# sourceMappingURL=PathModuleConfigBuilder.js.map